// Build a safe onsubmit confirm() attribute (MT-051): JSON.stringify makes the
// message a valid JS string literal (quotes in record names included), and the
// handler is then entity-escaped for the HTML-attribute context.
function confirmSubmitAttr(message) {
    var js = 'return confirm(' + JSON.stringify(String(message)) + ');';
    return 'onsubmit="' + js.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;') + '"';
}

import dt from 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
function toggle(className, displayState){
    var elements = document.getElementsByClassName(className);
    for (var i = 0; i < elements.length; i++){
        elements[i].style.display = displayState;
    }
}
function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

/**
 * URL Param by name (eg. ?parcelManager=true)
 */
function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
  
function replaceNotificationBody(evt) {
    let inputValue = evt.target.value;
    let inputType = evt.target.dataset.type;

    // if empty & not image
    if(inputValue == '' && inputType != 'image') {
        $('.announce-'+inputType+'-replacement').text(annDefaults[inputType]);
    }else if(inputType != 'image'){
        $('.announce-'+inputType+'-replacement').text(inputValue);
    }
}

let annFormInput = $('.announcement-form input');
let annDefaults = {
    'title' : 'Notification example title',
    'body'  : 'Notification body content, start typing to preview your content...'
};

// on title, body editing - update preview.
$('.announcement-form input').on('keyup', debounce((evt) => replaceNotificationBody(evt), 200));
$('.announcement-form textarea').on('keyup', debounce((evt) => replaceNotificationBody(evt), 200));

// on image selection - update preview.
$('.announcement-form input[type=file]').on('change', debounce(function(evt){
    let inputType = evt.target.dataset.type;

    // now lets do the image
    if(inputType === 'image') {
        if(evt.target.files.length > 0){
        var src = URL.createObjectURL(evt.target.files[0]);
        $(".announce-image-replacement").attr('src', src);
        }
    }
    
}, 200));

/**
 * Hide date on publish now
 */

var checkSendType = function() {
    if($('select[name=publish_when]').val() == 'datetime') {
        return 'Send Later';
    }else{
        return 'Send Now';
    }
}

$('.form-draft').on('change', function(){
    if(!$(this).is(':checked')){
        $('.btn-save-text').text('Save Draft');
    }else{
        $('.btn-save-text').text(checkSendType());
    }
});

$('select[name=publish_when]').on('change', function(e){

    // if draft is checked
    if( $('.form-draft').is(':checked') == false ){
        
        $('.btn-save-text').text('Save Draft');

        if($(this).val() == 'datetime') {
            $('.publish_when_date-container').fadeIn();
        }else{
            $('.publish_when_date-container').fadeOut();
            $('.publish_when_date-container input').val('');
        }

    }else{

        if($(this).val() == 'datetime') {
            $('.publish_when_date-container').fadeIn();
            $('.btn-save-text').text('Send Later');
        }else{
            $('.publish_when_date-container').fadeOut();
            $('.publish_when_date-container input').val('');
            $('.btn-save-text').text('Send Now');
        }

    }
});


/**
 * Announcement Type Selection
 */
$('#announcement_type').on('change', function(){
    var type = $(this).val();
    $('.announcement-individual-field').hide();
    $('.announcement-group-field').hide();
    $('.announcement-content-type-field').hide();

    if(type == 'individual') {
        $('.announcement-individual-field').fadeIn();
        $('.announcement-content-type-field').fadeIn();
    } else if(type == 'group') {
        $('.announcement-group-field').fadeIn();
    }
});

/**
 * Announcement Templates
 */
if(document.getElementById('announcementTemplates') !== null){

    let announcementTemplatesInput = document.getElementById('announcementTemplates').value,
        announcementJson = JSON.parse(announcementTemplatesInput);


    // console.log('announcementJson', announcementJson);

    $('#chooseAnnouncementTemplate').on( 'change', function(e){

        let selectedId = $(this).val();

        // console.log('selectedId', selectedId)

        if(selectedId == '') {
            $('input[name=title]').val('');
            $('textarea[name=body]').val('');
            return;
        }

        announcementJson.forEach(element => {
            if(element.id == selectedId) {
                // console.log('element', element);
                $('input[name=title]').val(element.title);
                $('textarea[name=body]').val(element.body);

                // has image?
                if(element.image){
                    // thumb url
                    let annImgUrlThumb = element.thumbnail_url;

                    $(".announce-image-replacement").attr('src', annImgUrlThumb);
                    $('.announcement-form .avatar').attr('src', annImgUrlThumb);

                    // hidden input, this will override the image field
                    $("<input>")
                    .attr({
                        type: "hidden",
                        name: "image_from_template",
                        value: element.image
                    })
                    .appendTo(".announcement-form");
                }

                // has button?

                if(element.button_text) {
                    $('input[name=button_text]').val(element.button_text);
                }else{
                    $('input[name=button_text]').val('');
                }

                if(element.button_link) {
                    $('input[name=button_link]').val(element.button_link);
                }else{
                    $('input[name=button_link]').val('');
                }

            }
        });

    });
}


document.addEventListener('DOMContentLoaded', function() {
    /** 
       * Generic user datatable configuration for properties table /properties
       */
      if(document.getElementsByClassName('hfs-data-announcement-table').length > 0){
    
        
    
        if(document.getElementsByClassName('hfs-data-announcement-table')[0].dataset.archive){
          
            var archive = true;
            var archiveStr = '?archive=true';
            var columns = [
                { 
                    data: 'title',
                    render: function(data, type, row) {
                        return announcementTitle(data, type, row);
                    },
                    className: 'align-middle'
                },
                { 
                    data: 'actions', 
                    render: function(data, type, row){
                        return announcementArchiveButtons(data, type, row);
                    },
                    className: 'align-middle text-end'
                },
            ];
    
        }else{
    
            var archive = false;
            var archiveStr = '';
            
            if(getParameterByName('tab') == 'direct'){

                var columns = [
                    { 
                        data: 'title',
                        render: function(data, type, row) {
                            return announcementTitle(data, type, row);
                        },
                        className: 'align-middle'
                    },
                    { 
                        data: 'publish_at',
                        className: 'align-middle',
                        width: 200,
                        render: function(data,type,row){
                            return publishedAt(data,type,row);
                        }
                    },
                    { 
                        data: 'processed_at',
                        className: 'align-middle',
                        width: 200,
                        render: function(data,type,row){
                            return processedAt(data,type,row);
                        }
                    },
                    { 
                        data: 'residents_count',
                        className: 'align-middle',
                        width: 200
                    },
                    { 
                        data: 'enabled', 
                        render: function(a,b,c){
                        return announcementEnabled(a,b,c);
                        },
                        className: 'align-middle',
                        width: 80
                    },
                    { 
                        data: 'actions', 
                        render: function(data, type, row){
                        return announcementButtons(data, type, row);
                        },
                        className: 'align-middle text-end',
                        width: 360
                    },
                ];

            }else{

                var columns = [
                    { 
                        data: 'title',
                        render: function(data, type, row) {
                            return announcementTitle(data, type, row);
                        },
                        className: 'align-middle'
                    },
                    { 
                        data: 'publish_at',
                        className: 'align-middle',
                        width: 200,
                        render: function(data,type,row){
                            return publishedAt(data,type,row);
                        }
                    },
                    { 
                        data: 'processed_at',
                        className: 'align-middle',
                        width: 200,
                        render: function(data,type,row){
                            return processedAt(data,type,row);
                        }
                    },
                    { 
                        data: 'enabled', 
                        render: function(a,b,c){
                        return announcementEnabled(a,b,c);
                        },
                        className: 'align-middle',
                        width: 80
                    },
                    { 
                        data: 'actions', 
                        render: function(data, type, row){
                        return announcementButtons(data, type, row);
                        },
                        className: 'align-middle text-end',
                        width: 360
                    },
                ];
            }
    
        }
    
        function publishedAt(data,display,row){
            var html = '';
            
            // console.log('publish at...', data, row);

            if(data != null){
                html += row.publish_at_formatted;
                html += '<br />';
                html += '<small>';
                html += row.published_at_formatted_human;
                html += '</small>';
            }else{
                html += 'Immediate';
            }

            return html;

        }

        function processedAt(data,display,row){
            var html = '';

            if(data != null){
                html += row.processed_at_formatted;
                html += '<br />';
                html += '<small>';
                html += row.processed_at_formatted_human;
                html += '</small>';
            }else{
                html += '-';
            }

            return html;

        }

        function announcementButtons(data, display, row){
        
          var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    
          var btnHTML = `
          <div class="btn-group">
            <a href="/announcements/`+row.id+`" class="btn btn-outline-secondary btn-sm" title="Show property">
              <i class="fa fa-eye fa-fw"></i> Show
            </a>
            <a href="/announcements/`+row.id+`/edit" class="btn btn-outline-secondary btn-sm" title="Edit property">
              <i class="fa fa-pencil fa-fw"></i> Edit
            </a>`;
    
          // ui hide, actual method is restricted server side.
            btnHTML += `
              <form method="POST" action="/announcements/`+row.id+`" accept-charset="UTF-8" `+confirmSubmitAttr('Do you really want to archive the announcement ' + row.title + '?')+`>
              <input name="_method" type="hidden" value="DELETE">
              <input name="_token" type="hidden" value="`+token+`">
              <input name="tab" type="hidden" value="`+(getParameterByName('tab') || 'scheduled')+`">
                <button type="submit" class="btn btn-outline-danger hfs-btn-table-delete btn-sm">
                  <i class="fa fa-trash fa-fw"></i> Archive
                </button>
              </form>`;
          
    
          btnHTML += `
          </div>`;
          
          return btnHTML;
    
        };
    
        function announcementArchiveButtons(data, display, row){
          
          var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    
          var btnHTML = `
          <div class="btn-group">
            <form method="POST" action="/announcements/archive/restore" accept-charset="UTF-8" `+confirmSubmitAttr('Do you really want to restore the announcement ' + row.title + '?')+`>
            <input name="_method" value="DELETE" type="hidden" />
            <input name="restore_id" type="hidden" value="`+row.id+`">
            <input name="_token" type="hidden" value="`+token+`">
    
              <button type="submit" class="btn btn-outline-danger  btn-sm">
                <i class="fa-solid fa-trash-arrow-up fa-fw"></i> Restore
              </button>
            </form>
          </div>`;
          
          return btnHTML;
    
        };
    
        function announcementTitle(data,display,row){
         
          var annHTML = `
          <div class="d-flex px-2 py-1">
            <div>`;
            if(!row.image_url){
              annHTML += `<img class="avatar avatar-sm me-3" src="/assets/img/placeholder.webp">`;
            }else{
              annHTML += `<img class="avatar avatar-sm me-3" src="`+row.image_url+`">`;
            }
          annHTML += `
            </div>
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-xs">`+row.title+`</h6>
              <small>`+row.body+`</small>
            </div>
          </div>`;
    
          return annHTML;
        };
    
        function announcementEnabled(data,b,c){
    
          var enabled = `
          <a href="javascript: void(0)" class="toggle-record" 
            data-table="announcements" 
            data-id="`+c.id+`" 
            data-column="enabled">`;
    
          if(data === 1){
            enabled += '<span class="badge text-light rounded-pill bg-success"><i class="fa fa-check fa-fw"></i></span>';
          }else{
            enabled += '<span class="badge bg-danger rounded-pill"><i class="fa fa-remove fa-fw"></i></span>';
          }
    
          enabled += `</a>`;
          return enabled;
        };
    
        // console.log('COLUMNS...', columns);

        let table = new dt('.hfs-data-announcement-table', {
          // processing: true,
          serverSide: true,
          lengthMenu: [ [10, 25, 50, -1], [10, 25, 50, "All"] ],
          columns: columns,
          rowId: 'id',
          order: [[ 0, 'asc' ]],
          ajax: '/announcements/ajax/json?tab='+getParameterByName('tab')+archiveStr,
          "autoWidth": false,
          "responsive": {
            details: {
                type: 'column',
                target: 'tr'
            }
          },
          "initComplete": function(settings, json) {
              toggle('hfs-spinner', 'none');
              toggle('hfs-table', 'table');
              toggle('hfs-card-nav', 'flex');
          }
        });
    
      }

});